__webpack_require__.hmrF = () => ("footer-view." + __webpack_require__.h() + ".hot-update.json");